import { motion, useReducedMotion, type HTMLMotionProps } from "framer-motion";
import { cn } from "@/lib/cn";

export type GlassCardProps = HTMLMotionProps<"div">;

export function GlassCard({
  className,
  whileHover,
  whileTap,
  transition,
  ...props
}: GlassCardProps) {
  const reduceMotion = useReducedMotion();
  return (
    <motion.div
      whileHover={
        reduceMotion ? undefined : (whileHover ?? { y: -1 })
      }
      whileTap={
        reduceMotion ? undefined : (whileTap ?? { scale: 0.995 })
      }
      transition={transition ?? { type: "spring", stiffness: 340, damping: 32 }}
      className={cn(
        "rounded-2xl border border-border/12 bg-panel/25 shadow-glow backdrop-blur-glass",
        "transition-colors hover:border-border/16 hover:bg-panel/28",
        className
      )}
      {...props}
    />
  );
}

